import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import Input from '../../../../../ui/canon/Input';
import { SendIcon, MailIcon } from 'lucide-react';

const EmailWidget = ({
  onAnswer,
  disabled,
  placeholder = 'Enter email address...',
  initialValue = '',
}) => {
  const [value, setValue] = useState(initialValue || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setValue(initialValue || '');
    setIsSubmitting(false);
    setError('');
  }, [initialValue]);

  const validateEmail = (email) => {
    if (!email.trim()) return '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (error) {
      setError(validateEmail(newValue));
    }
  };

  const handleBlur = () => {
    setError(validateEmail(value));
  };

  const handleSubmit = () => {
    const validationError = validateEmail(value);
    if (validationError) {
      setError(validationError);
      return;
    }

    if (value.trim() && !isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: value.trim() });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const isValid = value.trim() && !validateEmail(value);

  return (
    <div className="space-y-3">
      <div className="relative">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-succession-text-muted">
          <MailIcon className="h-4 w-4" />
        </div>
        <Input
          type="email"
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled || isSubmitting}
          className="pl-10"
        />
      </div>
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
      <Button
        onClick={handleSubmit}
        disabled={!isValid || disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        Submit Answer
      </Button>
    </div>
  );
};

export default EmailWidget;
